/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */
import {serviceGetAppSettings, serviceUpdateGeoFence,serviceUpdatePolicies,} from "../services/AppSettings.service";
import {serviceGetClientThemeByDomain} from "../services/index.services";
import EventEmitter from "../libs/Events.utils";

export const APP_SETTINGS_INIT = 'APP_SETTINGS_INIT';
export const APP_SETTINGS_DONE = 'APP_SETTINGS_DONE';
export const APP_SETTINGS_UPDATE_GEOFENCE = 'APP_SETTINGS_UPDATE_GEOFENCE';
export const APP_SETTINGS_CHANGE_THEME = 'APP_SETTINGS_CHANGE_THEME';
export const APP_SETTINGS_UPDATE_POLICIES = 'APP_SETTINGS_UPDATE_POLICIES';
export const CLIENT_THEME_LOADED = 'CLIENT_THEME_LOADED';

export function actionGetAppSettings(data) {
    const req = serviceGetAppSettings({});
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_INIT, payload: {} });
        req.then((data) => {
            if (!data.error) {
                const tempData = data.data;
                dispatch({ type: APP_SETTINGS_DONE, payload: tempData });
            }
        });
    };
    // return ({type: AUTH_USER, payload: data});
}


export function actionUpdateGeoFence(data) {
    const request = serviceUpdateGeoFence({ polygon: data } )
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_GEOFENCE, payload: data })
    }
}

export function actionChangeTheme(theme) {
    return (dispatch) => {
        localStorage.setItem('theme', theme);
        dispatch({type: APP_SETTINGS_CHANGE_THEME, payload: theme});
    }
}

export function actionUpdatePolicies(name, value) {
    const request = serviceUpdatePolicies({ name, value } ).then((res) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved Successfully', type: 'success'});
    });
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_POLICIES, payload: {name, value} })
    }
}

export function actionGetClientTheme(domain) {
    return (dispatch) => {
        // On application load check localstorage for theme
        let cachedTheme = null;
        try {
            cachedTheme = localStorage.getItem(`client_theme_${domain}`);
        } catch (e) {
            // ignore localStorage read error
        }

        if (cachedTheme) {
            try {
                const parsedTheme = JSON.parse(cachedTheme);
                // If theme values are still there -> update ui theme
                dispatch({ type: CLIENT_THEME_LOADED, payload: parsedTheme });
            } catch (e) {
                // ignore parsing error
            }
        }

        // Call API
        const req = serviceGetClientThemeByDomain({});
        req.then((data) => {
            const isSuccess = data?.response_code === 1 || (!data?.error && data?.data?.response_code === 1);
            if (isSuccess) {
                const themeData = data?.response_obj?.theme?.theme || data?.data?.response_obj?.theme?.theme;
                if (themeData) {
                    // Update localstorage and ui theme
                    try {
                        localStorage.setItem(`client_theme_${domain}`, JSON.stringify(themeData));
                    } catch (e) {
                        console.error('Failed to save client theme to localStorage:', e);
                    }
                    dispatch({ type: CLIENT_THEME_LOADED, payload: themeData });
                } else {
                    // Success response code, but theme object not found
                    try {
                        localStorage.removeItem(`client_theme_${domain}`);
                    } catch (e) {
                        console.error('Failed to remove client theme from localStorage:', e);
                    }
                    dispatch({ type: CLIENT_THEME_LOADED, payload: null });
                }
            } else {
                // Cache invalidation on failure or "not found" (domain deleted, deactivated, error)
                try {
                    localStorage.removeItem(`client_theme_${domain}`);
                } catch (e) {
                    console.error('Failed to remove client theme from localStorage:', e);
                }
                dispatch({ type: CLIENT_THEME_LOADED, payload: null });
            }
        }).catch((err) => {
            console.error('Error fetching client theme:', err);
        });
    };
}
